import { TaxReportCountry, VatTaxReportType } from 'store/app/enums';
import { User } from 'store/auth/models';
import { TaxRate } from 'store/returns/models/returnData';

export enum AdjustStatus {
  ADJUSTED_TRANSACTIONS = 'ADJUSTED_TRANSACTIONS',
  ADJUSTED_TOTALS = 'ADJUSTED_TOTALS',
}

export interface VatObligation {
  startDate: string | null;
  endDate: string | null;
  status: string | null;
  periodKey: string | null;
  message: string | null;
}

export interface VatRunData {
  adjustStatus: AdjustStatus;
  mappingId: string;
  tokenId: string;
  fromDate: string;
  toDate: string;
  currency: string;
  jsonMapping: string;
  openDataLogId: string;
  dataLogId: string;
  generationPeriod: string;
  generatedDate: string;
  validRange: boolean;
  taxReportCountry: TaxReportCountry;
  isPeriodClosed: boolean;
  reportingTypeId: string;
  taxReportTypeName: string;
  isFirstTime: boolean;
  connectionName: string;
  savable: boolean;
  taxType: VatTaxReportType;
  shortCode: string;
  status?: string;
  preparer?: string;
  preparerId?: string;
  reviewer?: string;
  reviewerId?: string;
  client: string;
  clientId: string;
  staff?: User[];
  clients?: User[];
  providerName: string;
  taxRates: TaxRate[];
  totalsSaved: boolean;
  updateFromProvider: boolean;
  hmrcPeriodKey?: string;
  obligation?: VatObligation[];
}
